// src/components/DashboardHome.jsx
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import styled, { keyframes } from 'styled-components';
import ContentView from './ContentView'; 
import axios from 'axios';
import searchIcon from './../assets/img/lupa.png';
import ReactSelect from 'react-select';
import { useLocation, useParams, useNavigate  } from 'react-router-dom';
import AnnouncementCarousel from './AnnouncementCarousel';
// --- SKELETON (idéntico al de ContentView para consistencia visual) ---
const shimmer = keyframes`
  0%   { left: -150px; }
  100% { left: 100%; }
`;

const SkeletonGrid = styled.ul`
  display: grid;
  grid-template-columns: ${props =>
    (!props.isLoggedIn || !props.isSidebarOpen) ? 'repeat(4, 1fr)' : 'repeat(3, 1fr)'};
  gap: 15px;
  padding: 15px;
  list-style: none;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
  @media (max-width: 1100px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 768px)  { grid-template-columns: repeat(2, 1fr); gap: 8px; padding: 8px; }
`;

const SkeletonItem = styled.li`
  background-color: ${props => props.active ? '#555' : '#e0e0e0'};
  border-radius: 8px;
  height: 320px;
  width: 100%;
  position: relative;
  overflow: hidden;
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0; left: -150px;
    height: 100%; width: 150px;
    background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0) 100%);
    animation: ${shimmer} 1.2s infinite;
  }
`;

const SkeletonWrapper = styled.div`
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
`;

// --- ESTILOS DASHBOARD ---

const GOLD = '#d9b97a';
const GOLD_DARK = '#9a7424'; // dorado con buen contraste sobre fondo claro

const DashboardContainer = styled.div`
  max-width: 100%;
  margin-top: -20px;
  @media (max-width: 768px) { margin-top: 20px; }
`;

const Header = styled.header`
  text-align: center;
  color: var(--text-main);

  /* Acerca el banner al encabezado (quita el hueco de abajo) */
  @media (min-width: 769px) {
    margin-bottom: -20px;
  }
`;

/* Nombre de la tienda (título principal) */
const StoreTitle = styled.h1`
  margin: 0;
  font-family: 'Montserrat', 'Poppins', 'Segoe UI', sans-serif;
  font-size: clamp(20px, 2.2vw, 28px);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: 0.6px;

  /* Letra blanca en modo oscuro, oscura en modo claro (sin borde) */
  color: ${props => (props.active ? '#ffffff' : '#1a1a1a')};
`;

/* Saludo (secundario) */
const WelcomeText = styled.h2`
  text-align: center;
  color: var(--text-main);
  opacity: 0.85;
  margin: 6px 0 0;
  font-size: 17px;
  font-weight: 500;
`;

/* Rol como chip */
const RoleChip = styled.span`
  display: inline-block;
  margin: 10px 0 0;
  padding: 4px 16px;
  border-radius: 999px;
  border: 1px solid ${props => (props.active ? 'rgba(217, 185, 122, 0.45)' : 'rgba(154, 116, 36, 0.5)')};
  background: ${props => (props.active ? 'rgba(217, 185, 122, 0.12)' : 'rgba(154, 116, 36, 0.1)')};
  color: ${props => (props.active ? GOLD : GOLD_DARK)};
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.4px;
`;

const FilterToggleBtn = styled.button`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    gap: 8px;
    background: transparent;
    border: 1px solid rgba(128,128,128,0.4);
    color: var(--text-main);
    padding: 8px 18px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    margin-bottom: 12px;
    transition: all 0.2s ease;
    &:hover { border-color: #a855f7; color: #a855f7; }
  }
`;

const TopRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 98%;
  gap: 20px;
  margin-bottom: 30px;
  @media (max-width: 768px) {
    display: ${p => p.showFilters ? 'flex' : 'none'};
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }
  @media (max-width: 1024px) and (min-width: 769px) {
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }
`;

const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;
  width: 350px;
  @media (max-width: 768px) { width: 100%; max-width: 350px; }
`;

const SearchInput = styled.input`
  width: 100%;
  height: 43px;
  font-size: 16px;
  padding: 0 15px;
  border: 1px solid ${props => props.active ? '#666' : '#ccc'};
  border-right: none;
  border-radius: 25px 0 0 25px;
  background-color: ${props => props.active ? '#333' : '#fff'};
  color: ${props => props.active ? 'white' : '#333'};
  outline: none;
  transition: all 0.3s ease;
  &::placeholder { color: ${props => props.active ? '#bbb' : '#888'}; }
`;

const SearchButton = styled.button`
  width: 60px;
  height: 45px;
  background-color: ${props => props.active ? '#333' : '#f0f0f0'};
  color: ${props => props.active ? 'white' : '#333'};
  border: 1px solid ${props => props.active ? '#666' : '#ccc'};
  border-left: none;
  border-radius: 0 25px 25px 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  &:hover { background-color: ${props => props.active ? '#444' : '#e0e0e0'}; }
  img { filter: ${props => props.active ? 'none' : 'invert(1)'}; }
`;

const DateFilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: ${props => props.active ? '#333' : '#fff'};
  color: ${props => props.active ? 'white' : '#333'};
  padding: 0 20px;
  height: 45px;
  border-radius: 25px;
  border: 1px solid ${props => props.active ? '#666' : '#ccc'};
  transition: all 0.3s ease;
  @media (max-width: 768px) {
    width: 100%;
    max-width: 350px;
    height: auto;
    padding: 15px 0;
    flex-direction: column;
    gap: 7px;
    border-radius: 20px;
    position: relative;
  }
`;

const DateInput = styled.input`
  background-color: transparent;
  border: none;
  color: ${props => props.active ? 'white' : '#333'};
  font-size: 14px;
  outline: none;
  cursor: pointer;
  width: 110px;
  &::-webkit-calendar-picker-indicator {
    filter: ${props => props.active ? 'invert(1)' : 'none'};
    cursor: pointer;
  }
  @media (max-width: 768px) {
    width: 130px;
    text-align: center;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
`;

const DesktopDivider = styled.div`
  color: #555;
  display: block;
  @media (max-width: 768px) { display: none !important; }
`;

const DateLabel = styled.span`
  font-size: 11px;
  color: #bbb;
  text-transform: uppercase;
  font-weight: bold;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const ClearDatesButton = styled.button`
  background: #444;
  color: #bbb;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  @media (max-width: 768px) { position: absolute; right: 12px; top: 12px; }
  &:hover { background: #555; color: white; }
`;

// --- COMPONENTE PRINCIPAL ---

const DashboardHome = ({ isLoggedIn, userId, role, token, username, updateNotificationCount, theme, isSidebarOpen, nombre, apellido, storeName }) => {
  const location = useLocation();
  const [themes, setThemes] = useState([]);
  const [selectedThemes, setSelectedThemes] = useState(() => {
    const params = new URLSearchParams(location.search);
    const theme = params.get('theme');
    return theme ? [theme] : [];
  });
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filterContents, setFilterContents] = useState(undefined);
  const [searchRecommends, setSearchRecommends] = useState({});
  const [isDetailView, setIsDetailView] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const { slug } = useParams();

  const navigate = useNavigate();
  const [stores, setStores] = useState([]);

  const [storeRif, setStoreRif] = useState(null);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/user/stores`);
        setStores(Array.isArray(res.data) ? res.data : []);
      } catch (error) {
        console.error('Error fetching stores:', error);
        setStores([]);
      }
    };
    fetchStores();
  }, []);

  // ── Opciones del select de tiendas (memoizadas para no recrear el array cada render) ──
  const storeOptions = useMemo(
    () => [
      { value: '', label: 'Todas las tiendas' },
        ...stores.map(s => ({ value: s.storeSlug, label: s.storeName, logo: s.storeLogo }))
    ],
    [stores]
  );

  // ── Valor seleccionado del select de tiendas ──
  // null => muestra el placeholder "Ver tiendas"
  // objeto opción => muestra la tienda seleccionada
  const [selectedStore, setSelectedStore] = useState(null);

  // Sincroniza el select con el slug actual de la URL (navegación directa, back/forward, etc.)
  useEffect(() => {
    if (slug) {
      const found = storeOptions.find(opt => opt.value === slug);
      setSelectedStore(found || null);
    } else {
      setSelectedStore(null);
    }
  }, [slug, storeOptions]);

  // ── CLAVE: skeleton visible desde el primer render, antes de cualquier API call ──
  const [initialLoading, setInitialLoading] = useState(true);

  const isDarkMode = theme === 'dark';

  // Carga la fuente Montserrat (solo una vez) para el título de la tienda
  useEffect(() => {
    const id = 'font-montserrat';
    if (window.document.getElementById(id)) return;
    const link = window.document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@800&display=swap';
    window.document.head.appendChild(link);
  }, []);

  const clearDates = () => { setStartDate(''); setEndDate(''); };

const handleSearch = useCallback(async () => {
  try {
    let results = [];

    if (slug) {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/user/store/${slug}`);
      results = response.data.contents || [];
      setStoreRif(response.data.store?.rif || null); // ← agregado
    } else {
      setStoreRif(null);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/user/search-contents`, {
        params: { term: searchTerm, startDate: startDate || undefined, endDate: endDate || undefined },
        headers: { Authorization: `Bearer ${token}` },
      });
      results = Array.isArray(response.data) ? response.data : [];
    }

    setFilterContents(results);
    setInitialLoading(false);

    if (results.length > 0) {
      const settled = await Promise.allSettled(
        results.map(content =>
          axios.get(
            `${process.env.REACT_APP_API_URL}/api/user/get-initial-recommend-counts/${content._id}`,
            { headers: { Authorization: `Bearer ${token}` } }
          ).then(r => ({ id: content._id, data: r.data }))
        )
      );
      const recommendsObject = {};
      const likeStatesObject = {};
      settled.forEach(r => {
        if (r.status === 'fulfilled' && r.value?.data) {
          recommendsObject[r.value.id] = r.value.data.recommends;
          likeStatesObject[r.value.id] = r.value.data.userRecommended;
        }
      });
      setSearchRecommends({ counts: recommendsObject, likeStates: likeStatesObject });
    }
  } catch (error) {
    console.error('Error buscando contenidos:', error);
    setFilterContents([]);
    setInitialLoading(false);
  }
}, [searchTerm, token, startDate, endDate, slug]);

  useEffect(() => {
  handleSearch();
}, [startDate, endDate, selectedThemes, handleSearch]);

  useEffect(() => {
    const fetchThemes = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/user/list-themes`, {
          headers: { authorization: `Bearer ${token}` }
        });
        setThemes(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error('Error fetching themes:', error);
        setThemes([]);
      }
    };
    fetchThemes();
  }, [token]);

  const displayName = nombre && nombre.trim() !== '' ? `${nombre} ${apellido}` : username;

  return (
    <DashboardContainer>
      {!isDetailView && (
        <Header>
          <div style={{ textAlign: 'center' }}>
            {isLoggedIn && (
              <>
                <StoreTitle active={isDarkMode}>{storeName || 'Edeli Store'}</StoreTitle>
                <WelcomeText>Bienvenid@, {displayName}</WelcomeText>
                <RoleChip active={isDarkMode}>{role}</RoleChip>
              </>
            )}
          </div>
        </Header>
      )}

      <ContentWrapper>
        {!isDetailView && (
          <>
            <AnnouncementCarousel theme={theme} />
            
            <FilterToggleBtn onClick={() => setShowFilters(p => !p)}>
              {showFilters ? '✕ Ocultar filtros' : '⚙ Filtros'}
            </FilterToggleBtn>

            <TopRow showFilters={showFilters}>
              <div style={{ width: 240, minWidth: 200 }}>
                <ReactSelect
                  placeholder="Ver tiendas"
                  noOptionsMessage={() => 'Sin tiendas'}
                  options={storeOptions}
                  value={selectedStore}
                  onChange={opt => {
                    if (!opt) return;
                    setSelectedStore(opt);
                    navigate(opt.value ? `/creador/${opt.value}` : '/dashboard');
                  }}
                  formatOptionLabel={(opt) => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      {opt.logo ? (
                        <img
                          src={opt.logo}
                          alt={opt.label}
                          style={{ width: 22, height: 22, borderRadius: '50%', objectFit: 'cover' }}
                        />
                      ) : (
                        <div style={{
                          width: 22, height: 22, borderRadius: '50%',
                          background: isDarkMode ? '#333' : '#e0e0e0',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          fontSize: 10, fontWeight: 700, color: isDarkMode ? '#fff' : '#555'
                        }}>
                          {opt.label?.charAt(0).toUpperCase()}
                        </div>
                      )}
                      <span>{opt.label}</span>
                    </div>
                  )}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      background: isDarkMode ? '#333' : '#fff',
                      borderColor: state.isFocused ? '#a855f7' : isDarkMode ? '#666' : '#ccc',
                      borderRadius: 25,
                      minHeight: 45,
                      boxShadow: 'none',
                      '&:hover': { borderColor: '#a855f7' },
                    }),
                    menu: (base) => ({
                      ...base,
                      background: isDarkMode ? '#333' : '#fff',
                      border: `1px solid ${isDarkMode ? '#555' : '#ccc'}`,
                      borderRadius: 12,
                      zIndex: 50,
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isFocused
                        ? isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)'
                        : 'transparent',
                      color: isDarkMode ? '#eee' : '#333',
                      fontSize: 13,
                      cursor: 'pointer',
                      borderRadius: 6,
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: isDarkMode ? '#bbb' : '#888',
                      fontSize: 14,
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: isDarkMode ? '#fff' : '#333',
                    }),
                    indicatorSeparator: () => ({ display: 'none' }),
                  }}
                />
              </div>
              <div style={{ width: 280, minWidth: 220 }}>
                <ReactSelect
                  isMulti
                  placeholder="Todas las temáticas"
                  noOptionsMessage={() => 'Sin resultados'}
                  options={themes.map(t => ({ value: t._id, label: t.name }))}
                  value={themes
                    .filter(t => selectedThemes.includes(t._id))
                    .map(t => ({ value: t._id, label: t.name }))}
                  onChange={opts => setSelectedThemes((opts || []).map(o => o.value))}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      background: isDarkMode ? '#333' : '#fff',
                      borderColor: state.isFocused ? '#a855f7' : isDarkMode ? '#666' : '#ccc',
                      borderRadius: 25,
                      minHeight: 45,
                      boxShadow: 'none',
                      '&:hover': { borderColor: '#a855f7' },
                    }),
                    menu: (base) => ({
                      ...base,
                      background: isDarkMode ? '#333' : '#fff',
                      border: `1px solid ${isDarkMode ? '#555' : '#ccc'}`,
                      borderRadius: 12,
                      zIndex: 50,
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected
                        ? isDarkMode ? 'rgba(168,85,247,0.2)' : 'rgba(168,85,247,0.1)'
                        : state.isFocused
                        ? isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)'
                        : 'transparent',
                      color: state.isSelected ? '#a855f7' : isDarkMode ? '#eee' : '#333',
                      fontWeight: state.isSelected ? 600 : 400,
                      fontSize: 13,
                      cursor: 'pointer',
                      borderRadius: 6,
                    }),
                    multiValue: (base) => ({
                      ...base,
                      background: isDarkMode ? 'rgba(168,85,247,0.15)' : 'rgba(168,85,247,0.1)',
                      borderRadius: 6,
                    }),
                    multiValueLabel: (base) => ({
                      ...base,
                      color: '#a855f7',
                      fontSize: 12,
                      fontWeight: 600,
                    }),
                    multiValueRemove: (base) => ({
                      ...base,
                      color: '#a855f7',
                      borderRadius: '0 6px 6px 0',
                      '&:hover': { background: 'rgba(239,68,68,0.15)', color: '#f87171' },
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: isDarkMode ? '#bbb' : '#888',
                      fontSize: 14,
                    }),
                    input: (base) => ({
                      ...base,
                      color: isDarkMode ? '#fff' : '#333',
                    }),
                    indicatorSeparator: () => ({ display: 'none' }),
                  }}
                />
              </div>

              <SearchBarContainer>
                <SearchInput
                  active={isDarkMode}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                  placeholder="Buscar contenido..."
                />
                <SearchButton onClick={handleSearch} active={isDarkMode}>
                  <img src={searchIcon} alt="Buscar" style={{ width: '18px' }} />
                </SearchButton>
              </SearchBarContainer>

              <DateFilterContainer active={isDarkMode}>
                <div style={{ display: 'flex', flexDirection: 'inherit', alignItems: 'center', width: '100%' }}>
                  <DateLabel>Desde</DateLabel>
                  <DateInput active={isDarkMode} type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                  <DesktopDivider>|</DesktopDivider>
                  <DateLabel>Hasta</DateLabel>
                  <DateInput active={isDarkMode} type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                </div>
                {(startDate || endDate) && (
                  <ClearDatesButton
                    onClick={clearDates}
                    title="Limpiar fechas"
                    style={window.innerWidth <= 768 ? { position: 'absolute', right: '15px', top: '50%', transform: 'translateY(-50%)' } : {}}
                  >
                    ✕
                  </ClearDatesButton>
                )}
              </DateFilterContainer>
            </TopRow>
          </>
        )}

        {/* ─── SKELETON INMEDIATO desde el primer render del componente ─── */}
        {initialLoading ? (
          <SkeletonWrapper>
            <SkeletonGrid isLoggedIn={isLoggedIn} isSidebarOpen={isSidebarOpen}>
              {Array.from({ length: 8 }).map((_, i) => (
                <SkeletonItem key={i} active={isDarkMode} />
              ))}
            </SkeletonGrid>
          </SkeletonWrapper>
        ) : (
          // ContentView solo se monta cuando ya tenemos datos → sin demoras internas
          <ContentView
            themeIds={selectedThemes}
            token={token}
            username={username}
            userId={userId}
            searchTerm={searchTerm}
            startDate={startDate}
            endDate={endDate}
            filterContents={filterContents}
            searchRecommends={searchRecommends}
            updateNotificationCount={updateNotificationCount}
            theme={theme}
            isLoggedIn={isLoggedIn}
            isSidebarOpen={isSidebarOpen}
            onViewDetailChange={setIsDetailView}
            storeRif={storeRif}
          />
        )}
      </ContentWrapper>
    </DashboardContainer>
  );
};

export default DashboardHome;